module.exports = __webpack_public_path__ + "img/noirepay.e0742a72.svg";